import captureSentryException from '@/features/app/functions/captureSentryException';
import GenericErrorComponent from '@/features/errors/components/generic-error-component';
import { Button } from '@thisisdmg/tirecloud-patterns/v2';
import { useTranslation } from 'react-i18next';

export default function Maintenance({
  message,
}: {
  message?: { title?: string; description?: string };
}) {
  const { t } = useTranslation();

  return (
    <div className="tw:h-1 tw:[min-height:inherit]">
      <GenericErrorComponent
        errorCode={[5, 0, 3]}
        errorMessage={
          <span
            dangerouslySetInnerHTML={{
              __html: message?.title ?? t('page.errors.maintenance.title'),
            }}
          />
        }
        errorDetails={
          <span
            dangerouslySetInnerHTML={{
              __html: message?.description ?? t('page.errors.maintenance.description'),
            }}
          />
        }
        actionButton={
          <div className="tc:inline-flex tc:gap-x-2">
            <Button.Solid
              color="brand"
              onClick={async () => {
                try {
                  // clear all caches
                  if (window.caches !== undefined) {
                    const keys = await window.caches.keys();
                    await Promise.all(keys.map((key) => window.caches.delete(key)));
                  }
                } catch (e) {
                  captureSentryException(e, {
                    message: 'failed to clear caches',
                    tags: {
                      feature: 'core.pwa',
                    },
                  });
                }
                window.location.reload();
              }}
            >
              {t('page.errors.maintenance.reloadBtn')}
            </Button.Solid>
          </div>
        }
      />
    </div>
  );
}
